<template>
  <v-row no-gutters justify="center">
    <!-- goal label -->
    <v-col cols="3" class="">
      <v-row align="center" class="fill-height" no-gutters>
        <v-col cols="2" align="center">
          <i :class="`v-icon patient-overview__icon ${icon}`"></i>
        </v-col>
        <v-col cols="10">
          <p justify="center" class="mt-4">
            {{ label }}
          </p>
        </v-col>
      </v-row>
    </v-col>
    <!-- status -->
    <v-col cols="2" align="center" no-gutters class="border-right pr-6">
      <v-row align="center" justify="center" style="height: 100%">
        <p :class="['border', 'pa-4', 'mt-4', 'mx-2', 'status', statusClass]" :style="{ maxWidth: '200px', width: '100%'}">
          {{ $ucfirst(status.label)|stripHTML }}
        </p>
      </v-row>

    </v-col>
    <!-- goal toggler -->
    <v-col cols="1" align="center">
      <v-row align="center" justify="center" style="height: 100%" class="ml-3">
        <v-switch
            v-model="switchValue"
            inset
            color="green"
            @change="toggleOutcomeGoal()"
        >
        </v-switch>
      </v-row>
    </v-col>
    <!-- reminder toggler-->
    <!-- <v-col cols="1" align="center">
      <v-row
          v-if="outcomeGoal === 'HEALTHY_WEIGHT' || outcomeGoal === 'LOWERING_BLOOD_PRESSURE'"
          align="center"
          justify="center"
          style="height: 100%"
          class="ml-3"
      >
        <v-switch
            v-model="switchReviewReminder"
            inset
            color="green"
            @change="toggleReviewReminder()"
        ></v-switch>
      </v-row>
    </v-col> -->
    <!-- add weight -->
    <v-col cols="6" class="mt-2">
      <goal-setting-outcome-goal-row-target-weight
          v-if="outcomeGoal === 'HEALTHY_WEIGHT'"
          :extraInformation="extraInformation"
      />
    </v-col>
  </v-row>
</template>

<script>
import gql from "graphql-tag";
import GoalSettingOutcomeGoalRowTargetWeight from "./GoalSettingOutcomeGoalRowTargetWeight.vue";
import {mapGetters} from "vuex";

/**
 * Component GoalSettingOutcomeGoalRow.vue
 *
 * @module GoalSettingOutcomeGoalRow
 * @date
 * @author
 * @copyright UniWeb bvba 2022
 *
 * @link https://gitlab.uniweb.be/cor/4.04-caregiver-dashboard
 *
 * @coropreventionSW [SW-4.5] app/src/APP_DASHBOARD/templates/components/Parts/GoalSettingOutcomeGoalRow.vue
 * @see https://docs.google.com/document/d/1iOpHH151s_ABr-DniJIc__q-GHpXJJVq/edit#heading=h.a0z8d9xd3xr7
 *
 */

export default {
  name: "GoalSettingOutcomeGoalRow",
  props: {
    //   Name
    outcomeGoal: {
      type: String,
    },
    icon: {
      type: String,
    },
    label: {
      type: String,
    },
    status: {
      type: Object,
    },
    // Setting path
    outcomeGoalPath: {
      type: String,
    },
    reviewReminderPath: {
      type: String,
    },
    extraInformation: {},
  },
  computed: {
    ...mapGetters({
      patientId: "patientSummary/id",
      outcomeComponents: "patientSummary/outcomeComponents",
    }),
  },
  created() {
  },
  data: function () {
    return {
      switchOutcomeGoal: true,
      switchValue: true,
      switchReviewReminder: true,
      statusClass: "null",
    };
  },
  watch: {
    motivation() {
      // this.setMotivationColor();
      this.setStatusColor();
    },
  },
  methods: {
    setStatusColor() {
      if (this.status.value != null) {
        this.statusClass = this.status.value;
      }
    },
    async toggleOutcomeGoal() {
      try {
        const result = await this.$app.apolloMobileClient
            .mutate({
              mutation: gql`
            mutation updateMyOutcomeComponent(
              $patientId: Int!
              $key: String!
              $active: Boolean
            ) {
              updateMyOutcomeComponent(
                patientId: $patientId
                key: $key
                active: $active
              ) {
                key
                active
              }
            }
          `,
              variables: {
                patientId: parseInt(this.patientId),
                key: this.outcomeGoal,
                active: this.switchValue,
              },
            });

        if (result) {
          this.switchOutcomeGoal = this.switchValue;
          console.log('Outcome goal updated');
          console.log(result);
          this.$store.dispatch('patientSummary/update');
        }
      } catch (error) {
        this.$toasted.error('Something went wrong, please contact the website administrator.');
        this.switchValue = this.switchOutcomeGoal;
      }
    },
    toggleReviewReminder() {
      this.$app.apolloMobileClient
          .mutate({
            mutation: gql`
            mutation updateMyOutcomeComponent(
              $patientId: Int!
              $key: String!
              $reviewReminders: Boolean
            ) {
              updateMyOutcomeComponent(
                patientId: $patientId
                key: $key
                reviewReminders: $reviewReminders
              ) {
                key
                reviewReminders
              }
            }
          `,
            variables: {
              patientId: parseInt(this.patientId),
              key: this.outcomeGoal,
              reviewReminders: this.switchReviewReminder,
            },
          })
          .then((result) => {
            this.$store.dispatch('patientSummary/update');
          });
    },
  },
  mounted: async function () {
    this.setStatusColor();

    this.switchOutcomeGoal = this.outcomeComponents.get(this.outcomeGoal).active;
    this.switchValue = this.switchOutcomeGoal;
    this.switchReviewReminder = this.outcomeComponents.get(this.outcomeGoal).reviewReminders;
  },
  components: {GoalSettingOutcomeGoalRowTargetWeight},
};
</script>

<style lang="scss" scoped>
@import "../../../../scss/colors";

.status {
  border-radius: 10px;
  color: black;
  border: none !important;
}

.null {
  background-color: #dedede;
}

.poor {
  background-color: rgba(244, 67, 54, 0.9);
}

.good {
  background-color: rgba(76, 175, 80, 0.9);
}

.moderate {
  background-color: rgba(255, 152, 0, 0.9);
}

</style>
